module.exports = __webpack_public_path__ + "static/media/Inter.9e3f1b2b.png";